import { Injectable, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { KeyValue } from '@angular/common';

import { interval, Observable, of, Subject, Subscription } from 'rxjs';
import { concatMap, map, takeUntil } from 'rxjs/operators';

import { LoggingMessageService } from './logging-message.service';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class TimeoutService implements OnInit, OnDestroy {

  constructor(private logger: LoggingMessageService) { }
    timeoutDecisionRequiredEvent = new EventEmitter<boolean>();
    timeoutDecisionExpiredEvent = new EventEmitter<boolean>();

    private $subscriptionsTimeoutCountdown: Subscription = new Subscription();
    private $subscriptions: Subscription = new Subscription();

    private timeoutDecisionCountdown$: Observable<number>;
    public timeoutCountdown$: Observable<number>;
    private timeoutDestroy$: Subject<boolean> = new Subject<boolean>();
    private timeoutDecisionDestroy$: Subject<boolean> = new Subject<boolean>();

    private timeoutCounter = 0;

    private _resetTimeoutDialogTimer = false;
    public get ResetTimeoutDialogTimer(): boolean {
        return this._resetTimeoutDialogTimer;
    }
    public set ResetTimeoutDialogTimer(value: boolean) {
        this._resetTimeoutDialogTimer = value;
    }


    ngOnInit(): void {

    }

    private subscribeToTimerCountdown() {
      const timerSubscription = this.timeoutCountdown$
        .subscribe(
          (remainingTime) => {
            this.timeoutCounter = remainingTime;
            if (remainingTime === 0) {
              console.log('Timeout Dialog timer expired. Trying to show timeout dialog');
              this.subscribeToTimeoutDecisionRequired();
              this.timeoutDecisionRequiredEvent.emit(true);
            }
          },
          (error) => {
            console.log("Timer Countdown error");
            // this.logger.warn('app.component', 'subscribeToTimerCountdown', this.subscriptionSelected, this.subscriptions, 'Timer Countdown error', error);
          },
          () => {
            console.log("Timer Countdown completed");
            // this.logger.info('app.component', 'subscribeToTimerCountdown', this.subscriptionSelected, this.subscriptions, 'Timer Countdown completed', '');
          }
        );
      this.$subscriptionsTimeoutCountdown.add(timerSubscription);
    }

    private subscribeToTimeoutDecisionRequired() {
      const decisionRequiredSubscription = this.timeoutDecisionRequiredEvent
          .subscribe((show) => {
            if (show === true) {
              this.resetDecisionTimer();
              this.subscribeToTimeoutDecisionCountdown();
            }
          });
      this.$subscriptions.add(decisionRequiredSubscription);
  }
  
    private subscribeToTimeoutDecisionCountdown() {
      const decisionSubscription = this.timeoutDecisionCountdown$
        .subscribe(
          (remainingTime) => {
            if (remainingTime === 0) {
              console.log("Timeout Dialog decision expired");
              this.timeoutLogOut();
              this.timeoutDecisionExpiredEvent.emit(true);
            }
          },
          (error) => {
            console.error('Error:', error);
          },
          () => {
            //console.log('Timeout decision completed');
          }
        );
      this.$subscriptions.add(decisionSubscription);
    }

    public timeoutStayLoggedIn() {
      // this.logger.info('app.component', 'timeoutStayLoggedIn', this.subscriptionSelected, this.subscriptions, 'User elected to stay logged in', '');
      this.destroyTimeout();
      this.resetTimeoutDialogTimer();
    }
  
    public timeoutLogOut() {
      this.destroyTimeout();
    }
  
  
    public resetTimeoutDialogTimer() {
      //console.log("Resetting Timeout Dialog timer");
      // this.logger.info('app.component', 'subscribeToTimerCountdown', this.subscriptionSelected, this.subscriptions, 'Resetting Timeout Dialog timer', '');
      this.ResetTimeoutDialogTimer = false;

      // Ununscribe from timer countdown
      this.timeoutDestroy$.next(true);
  
      // reset timer
      this.timeoutCountdown$ = this.startTimer(environment.TimeoutDialogDuration);
      // resubscribe
      this.subscribeToTimerCountdown();
    }
  
    public resetDecisionTimer() {
      this.timeoutDecisionCountdown$ = this.startDecisionTimer(environment.TimeoutDecisionTime);
    }
  
    private startTimer(duration: number): Observable<number> {
      return interval(1000).pipe(
        takeUntil(this.timeoutDestroy$),
        map((seconds: number) => duration - seconds)
      );
    }
  
    private startDecisionTimer(duration: number): Observable<number> {
      return interval(1000).pipe(
        takeUntil(this.timeoutDecisionDestroy$),
        map((seconds: number) => duration - seconds)
      );
    }

    public destroyTimeout() {
      this.timeoutDestroy$.next(true);
      this.timeoutDecisionDestroy$.next(true);
    }

    private completeTimeout() {
      this.timeoutDestroy$.complete();
      this.timeoutDecisionDestroy$.complete();
    }

    unsubscribe() {
      if (this.$subscriptions) {
          this.$subscriptions.unsubscribe();
      }

      if (this.$subscriptionsTimeoutCountdown) {
        this.$subscriptionsTimeoutCountdown.unsubscribe();
      }

      this.destroyTimeout();
      this.completeTimeout();
    }

    ngOnDestroy(): void {
      this.unsubscribe();
    }
}

